export default __webpack_public_path__ + "static/media/bg_main_invest.1a49d00c56d2c270c83ac846aba48b86.svg";